export default function InfoIcon({ className, variant }: { className?: string; variant?: number }) {
  if (variant === 3) {
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none">
        <path
          d="M8.00065 1.33398C11.6827 1.33398 14.6673 4.31865 14.6673 8.00065C14.6687 9.75097 13.9817 11.4316 12.7546 12.6797C11.5275 13.9279 9.85875 14.6434 8.10867 14.6717C6.35858 14.7001 4.66754 14.039 3.40065 12.8313C2.13376 11.6236 1.39264 9.96609 1.33732 8.21665L1.33398 8.00065L1.33665 7.81398C1.43532 4.21865 4.38065 1.33398 8.00065 1.33398ZM8.00065 7.33398H7.33398L7.25598 7.33865C7.09395 7.35792 6.94461 7.43596 6.83626 7.55796C6.72791 7.67997 6.66806 7.83748 6.66806 8.00065C6.66806 8.16383 6.72791 8.32133 6.83626 8.44334C6.94461 8.56535 7.09395 8.64338 7.25598 8.66265L7.33398 8.66732V10.6673L7.33865 10.7453C7.3562 10.8941 7.42337 11.0327 7.52933 11.1386C7.63528 11.2446 7.77384 11.3118 7.92265 11.3293L8.00065 11.334H8.66732L8.74532 11.3293C8.89413 11.3118 9.03269 11.2446 9.13864 11.1386C9.2446 11.0327 9.31177 10.8941 9.32932 10.7453L9.33398 10.6673L9.32932 10.5893C9.31338 10.4533 9.25594 10.3255 9.16481 10.2233C9.07368 10.1211 8.95328 10.0494 8.81998 10.018L8.74532 10.0047L8.66732 10.0007V8.00065L8.66265 7.92265C8.6451 7.77384 8.57793 7.63528 8.47198 7.52933C8.36602 7.42337 8.22746 7.3562 8.07865 7.33865L8.00065 7.33398ZM8.00732 5.33398L7.92265 5.33865C7.76062 5.35792 7.61128 5.43596 7.50293 5.55796C7.39457 5.67997 7.33473 5.83748 7.33473 6.00065C7.33473 6.16383 7.39457 6.32133 7.50293 6.44334C7.61128 6.56535 7.76062 6.64338 7.92265 6.66265L8.00065 6.66732L8.08532 6.66265C8.24735 6.64338 8.39669 6.56535 8.50504 6.44334C8.6134 6.32133 8.67324 6.16383 8.67324 6.00065C8.67324 5.83748 8.6134 5.67997 8.50504 5.55796C8.39669 5.43596 8.24735 5.35792 8.08532 5.33865L8.00732 5.33398Z"
          fill="currentColor"
        />
      </svg>
    );
  }
  if (variant === 2) {
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none">
        <path
          d="M10 7.5H10.0083M9.16667 10H10V13.3333H10.8333M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 8.01088 16.7098 6.10322 15.3033 4.6967C13.8968 3.29018 11.9891 2.5 10 2.5C8.01088 2.5 6.10322 3.29018 4.6967 4.6967C3.29018 6.10322 2.5 8.01088 2.5 10Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M10 7.5H10.0083M9.16667 10H10V13.3333H10.8333M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 8.01088 16.7098 6.10322 15.3033 4.6967C13.8968 3.29018 11.9891 2.5 10 2.5C8.01088 2.5 6.10322 3.29018 4.6967 4.6967C3.29018 6.10322 2.5 8.01088 2.5 10Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
